import { render } from "./File.vue?vue&type=template&id=2f132ea1"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"
script.render = render

export default script